import { Box, Flex, Heading } from '@utilitywarehouse/hearth-react';
import { semantic } from '@utilitywarehouse/hearth-tokens/browser';
import { useRef, useState } from 'react';

import { Carousel, CarouselRef } from '@components/Carousel';
import { CarouselControls } from '@components/CarouselControls';

import { EarningsMilestoneSlide } from './EarningsMilestoneSlide';
import { EARNINGS_MILESTONES } from './constants';
import './styles.scss';

const EarningsMilestones = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const carouselRef = useRef<CarouselRef>(null);

  return (
    <Flex
      direction="column"
      alignItems="center"
      paddingY={{ mobile: '350', desktop: '500' }}
      gap="400"
      width="100%"
      className="earnings-milestones"
      backgroundColor={semantic.surface.cashback.subtle}
    >
      <Box className="wrapper">
        <Box className="earnings-milestones__card">
          <Flex direction="column" alignItems="center" gap="400" width="100%">
            <Heading
              as="h2"
              size="xl"
              textAlign="center"
              className="earnings-milestones__title"
            >
              What could your cashback earnings buy?
            </Heading>

            <Carousel
              id="earnings-milestones"
              ref={carouselRef}
              settings={{
                arrows: false,
                fade: true,
                adaptiveHeight: true,
                infinite: true,
                autoplay: true,
                autoplaySpeed: 5000,
                beforeChange: (_current, next) => setActiveIndex(next),
              }}
            >
              {EARNINGS_MILESTONES.map((milestone) => (
                <div key={milestone.monthlyAmount}>
                  <EarningsMilestoneSlide milestone={milestone} />
                </div>
              ))}
            </Carousel>
          </Flex>
        </Box>
      </Box>
      <CarouselControls
        count={EARNINGS_MILESTONES.length}
        activeIndex={activeIndex}
        onSelect={(index) => carouselRef.current?.slickGoTo(index)}
        onPrev={() => carouselRef.current?.slickPrev()}
        onNext={() => carouselRef.current?.slickNext()}
        itemLabel="milestone"
      />
    </Flex>
  );
};

export { EarningsMilestones };
